import { TRootState } from "../../reducers/RootReducer";

const selectSubsetOptions = (subsetId?: number) => (store: TRootState) => {
  if (!subsetId) {
    return null;
  }

  return store.subsetOptionsBySubsetId[subsetId]?.data
}

export {
  selectSubsetOptions
}
